import ApiService from "../../commons/api/api_service";
import BaseResponse from "../../commons/api/base_response";
import { Endpoints } from "../../commons/api/endpoints";
import ViewModel from "../../commons/base/view_model";
import SoldOutItemDashboardState from "../models/sold_out_item_dashboard_state";
import SoldOutItem from "../models/sold_out_item_model";

export default interface ResponseModel {
    soldOutItemPerOutlet: {
        outlet: string;
        majorItems: SoldOutItem[],
        minorItems: SoldOutItem[]
    }[]
}

export default class SoldOutItemDashboardViewModel extends ViewModel<SoldOutItemDashboardState> {

    constructor() {
        super({
            majorItemPerOutlet: new Map(),
            minorItemPerOutlet: new Map()
        });
        this.loadData();
    }

    loadData() {
        ApiService.fetch(Endpoints.getSoldOutItem, {
            onSuccess: (
                response: BaseResponse<ResponseModel>
            ) => {
                if (response && response.code == 200) {
                    const newData = response.data?.soldOutItemPerOutlet;
                    if (newData) {
                        const newMajor = new Map();
                        const newMinor = new Map();
                        newData.forEach((data) => {
                            newMajor.set(data.outlet, data.majorItems);
                            newMinor.set(data.outlet, data.minorItems);
                        });
                        this.emit((state) => {
                            state.majorItemPerOutlet = newMajor;
                            state.minorItemPerOutlet = newMinor;
                        });
                    }
                } else {
                    throw new Error("Terjadi error, silakan coba refresh halaman web");
                }
            },
            onFailure: (error) => {
                this.emit((state) => {
                    state.errorMessage = "Terjadi error, silakan coba refresh halaman web";
                });
            }
        });
    }
}